import TourProductObjectValue from '../ObjectValue/TourProduct';

const TourProductsRepository = Backbone.Collection.extend({
    model: TourProductObjectValue,
    getOnlyTourProducts() {
        return this.filter((tourProduct) => tourProduct.get('type') === 'TourProduct');
    },
});

export default TourProductsRepository;